import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Images from '@src/mobile/components/Images';
import TimeListVideo from '@/src/mobile/components/TimeListVideo';
import Link from '@src/mobile/components/Link';
import { EVENT_LIST_INFLOW, EVENT_LIST_MYFOLLOW } from '@src/public/constants';
import { inFlowIframeJump } from '@src/public/utils';
import { isGrounds } from '@src/public/utils/app';
import styles from './index.css';
import Milestone from '../../Milestone';
import Watermark from '../../Watermark';

const cx = classNames.bind(styles);

const Content = ({ content, showType, timeline }) => {
    const {
        img,
        video,
        description,
        link,
        milestone,
        watermark,
        longImg,
        title,
        cardBgColor = '#FFFFFF',
        showBlink = false,
    } = content;
    const { id } = timeline;

    let desc = '';
    const imgList = img && Array.isArray(img) ? [...img] : [];

    if (longImg) {
        desc = title;
        imgList.unshift({ url: longImg });
    } else {
        desc = description || title;
    }

    return (
        <div className={styles.bg} style={{ backgroundColor: cardBgColor }}>
            <div className={cx('wrap', { wrapBlink: showBlink, wrapMyFollow: showType === EVENT_LIST_MYFOLLOW })}>
                <div className={styles.desc}>
                    <Milestone id={milestone} />
                    <span
                        className={styles.descText}
                        dangerouslySetInnerHTML={{ __html: desc.replace(/\n/g, '<br />') }}
                    />
                    {link ? (
                        <>
                            {showType === EVENT_LIST_INFLOW && !isGrounds ? (
                                <div
                                    className={styles.descLink}
                                    style={{ color: '#3091f5' }}
                                    onClick={() => {
                                        inFlowIframeJump(link.url);
                                    }}>
                                    {link.title}
                                </div>
                            ) : (
                                <Link
                                    to={link.url}
                                    className={styles.descLink}
                                    style={{ color: '#3091f5' }}
                                    timelineId={id}
                                    needLinkAnalyze={true}>
                                    {link.title}
                                </Link>
                            )}
                        </>
                    ) : null}
                    <Watermark id={watermark} />
                </div>
                {imgList.length ? (
                    <div className={styles.picWrap}>
                        <Images img={imgList} showType={showType} id={id} />
                    </div>
                ) : null}
                {video && video.url ? (
                    <div className={styles.videoWrap}>
                        <TimeListVideo
                            videoConfig={{ mobileUrl: video.url, bigPosterUrl: video.poster }}
                            showType={showType}
                            timeId={id}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

Content.propTypes = {
    content: PropTypes.object.isRequired,
    showType: PropTypes.string,
    timeline: PropTypes.object.isRequired,
};

export default errorBoundary(Content);
